module.exports = __webpack_public_path__ + "img/admin-menu.14648d22.png";